import { useEffect } from 'react';
import { LoadingModal } from './LoadingModal';
import { useSelector, useDispatch } from 'react-redux';
import { clearError, deleteEquipment } from '../redux/slices/equipmentsSlice';

const DeleteEquipmentModal = ({ setDeleteModal, setViewEquipment, viewEquipment }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.equipments.loading);
  const error = useSelector((state) => state.equipments.error);

  useEffect(() => {
    // Clear any existing errors when component mounts
    dispatch(clearError());

    // Clean up when component unmounts
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleDismissError = () => {
    dispatch(clearError());
    setDeleteModal(false);
    setViewEquipment(null);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(deleteEquipment(viewEquipment._id)).unwrap();

      setDeleteModal(false);
      setViewEquipment(null);
    } catch (error) {
      console.error('Error deleting equipment:', error);
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      {(loading || error) && (
        <LoadingModal
          message="Deleting equipment..."
          error={error}
          onClose={error ? handleDismissError : null}
        />
      )}
      {!loading && !error && (
        <div className="bg-white p-8 rounded-md shadow-lg w-1/2 max-w-lg">
          <form onSubmit={handleDelete}>
            <label className="block mb-2 text-lg font-bold">
              Are You Sure You Want To <span className="text-red-600">Delete </span> This Equipment?{' '}
              <div className="text-center font-semibold my-4 text-lg">{viewEquipment.name}</div>
            </label>
            <div className="flex justify-end">
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Deleting...' : 'Confirm'}
              </button>
              <button
                className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
                onClick={() => {
                  setDeleteModal(false);
                  setViewEquipment(null);
                }}
                type="button"
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export { DeleteEquipmentModal };
